export enum QueryKeys {
  applicationDetail = 'applicationDetail',
  applicationHistory = 'applicationHistory',
  liveliness = 'liveliness',
  masterEntityOptions = 'masterEntityOptions',
  productLists = 'productLists',
  searchCity = 'searchCity',
  vehicleBrands = 'vehicleBrands',
  vehicleCity = 'vehicleCity',
  vehicleModels = 'vehicleModels',
  vehicleProvince = 'vehicleProvince',
  vehicleProvinceCity = 'vehicleProvinceCity',
  vehicleYear = 'vehicleYear',
  livelinessResult = 'livelinessResult',
  getUserInfo = 'userInfo',
  userInfoWithCode = 'userInfoWithCode',
  branchList = 'branchList',
  branchBravoList = 'branchBravoList',
  provinceById = 'provinceById',
  cityById = 'cityById',
  districtById = 'districtById',
  subDistrictById = 'subDistrictById',
  uploadedSelfie = 'uploadedSelfie',
  verifyApplicationStatus = 'verifyApplicationStatus',
  surveyorDetails = 'surveyorDetails',
  feedbackQuestions = 'feedbackQuestions',
  selfieIsUploaded = 'selfieIsUploaded',
  verifyKTPAttempt = 'verifyKTPAttempt',
}
